import Vue from "vue";
import Certificate from "@/models/Certificate";

export default class LicenseApi {

    constructor(api) {
        this.api = api;
    }

    getByTerm(term, callback, error) {
        this.api.getRaw((axios) => {
            axios.get("certificates?searchTerm=" + term).then((response) => {
                callback(response.data.map((date) => new Certificate(date)));
            }).catch((err) => {
                if (error) error(err)
                else Vue.$log.error("Error", error);
            });
        });
    }
}
